import { Builder } from '@builder.io/react';
import { isNullOrUndefined } from '../../utils';
export const comparisons = {
    isTrue: 'is true',
    isFalse: 'is false',
    equals: 'equals',
    doesNotEqual: 'does not equal',
    contains: 'contains',
    doesNotContain: 'does not contain',
    startsWith: 'starts with',
    doesNotStartWith: 'does not start with',
    endsWith: 'ends with',
    doesNotEndWith: 'does not end with',
};
function conditionIsSatisfied(condition) {
    const { source, comparison, andConditions, orConditions } = condition;
    let target = condition.target;
    let satisfied = true;
    /**
     * Convert type of `target` to match `source` if needed.
     * If it can't be converted, set `satisfied` to false to skip the comparison.
     */
    if (typeof source === 'number') {
        const f = parseFloat(target);
        if (!isNaN(f)) {
            target = f;
        }
        else {
            satisfied = false;
        }
    }
    if (satisfied) {
        switch (comparison) {
            case comparisons.isTrue: {
                satisfied = !!source;
                break;
            }
            case comparisons.isFalse: {
                satisfied = !source;
                break;
            }
            case comparisons.equals: {
                satisfied = !isNullOrUndefined(source) && source === target;
                break;
            }
            case comparisons.doesNotEqual: {
                satisfied = isNullOrUndefined(source) || source !== target;
                break;
            }
            case comparisons.contains: {
                satisfied =
                    !isNullOrUndefined(source) &&
                        typeof source === 'string' &&
                        source.includes(target);
                break;
            }
            case comparisons.doesNotContain: {
                satisfied =
                    isNullOrUndefined(source) ||
                        typeof source !== 'string' ||
                        !source.includes(target);
                break;
            }
            case comparisons.startsWith: {
                satisfied =
                    !isNullOrUndefined(source) &&
                        typeof source === 'string' &&
                        source.startsWith(target);
                break;
            }
            case comparisons.doesNotStartWith: {
                satisfied =
                    isNullOrUndefined(source) ||
                        typeof source !== 'string' ||
                        !source.startsWith(target);
                break;
            }
            case comparisons.endsWith: {
                satisfied =
                    !isNullOrUndefined(source) &&
                        typeof source === 'string' &&
                        source.endsWith(target);
                break;
            }
            case comparisons.doesNotEndWith: {
                satisfied =
                    isNullOrUndefined(source) ||
                        typeof source !== 'string' ||
                        !source.endsWith(target);
                break;
            }
            default: {
                satisfied = false;
            }
        }
    }
    // No need to check that all AND conditions are satisfied if the root
    // condition is not satisfied
    if (satisfied && andConditions && andConditions.length > 0) {
        satisfied = andConditions.every((c) => conditionIsSatisfied(c));
    }
    // No need to check that some OR condition is satisfied if the root
    // condition + AND conditions are already satisfied
    if (!satisfied && orConditions && orConditions.length > 0) {
        satisfied = orConditions.some((c) => conditionIsSatisfied(c));
    }
    return satisfied;
}
export function ConditionalVisibility(props) {
    if (Builder.isEditing || Builder.isPreviewing) {
        return props.preview ? props.children : null;
    }
    return conditionIsSatisfied(props) ? props.children : null;
}
//# sourceMappingURL=ConditionalVisibility.js.map